import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { requestUserNotificacion } from "../../../notification";
import ConfirmDialog from "../ConfirmDialog";

const WebNotificationDialog = () => {
    const [isOpen, setisOpen] = useState(false);

    const handleConfirmNotifications = () => {
        setisOpen(false);
        requestUserNotificacion();
    };
    const handleCancelNotifications = () => {
        setisOpen(false);
    };
    useEffect(() => {
        if (Notification.permission === "default") {
            setisOpen(true);
        }
    }, []);

    return (
        <ConfirmDialog
            open={isOpen}
            message={"Would you like to receive notifications from this website?"}
            btnConfirm={
                <Button color="secondary" onClick={handleConfirmNotifications}>
                    Yes
                </Button>
            }
            onCancel={handleCancelNotifications}
        />
    );
};

export default WebNotificationDialog;
